import { isCommentNode, isTextNode, isTag, isNonEmptyTextNode } from 'anodum';
import { BREAK_TAG, IMAGE_TAG } from '../constants/editable-elements';
import hasNodeContent from './has-node-content';

// This verifier returns true if the element is not supported
// It detects: unsupported tags, empty text nodes, empty elements,
// comment nodes, elements with "dislpay: none;"

const isElementToRemove = (element) => {
  if (isCommentNode(element)) return true;

  if (isTextNode(element)) return !isNonEmptyTextNode(element);

  if (element.style.display === 'none') return true;

  if (isTag(element, IMAGE_TAG)) return !element.src;

  if (isTag(element, BREAK_TAG)) return false;

  return !hasNodeContent(element);
};

export default isElementToRemove;
